export const DragIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
        <circle cx="1.7207" cy="2.01953" r="1.17188" fill="#D9D9D9"/>
        <circle cx="1.7207" cy="7.96484" r="1.17188" fill="#D9D9D9"/>
        <circle cx="1.7207" cy="13.9102" r="1.17188" fill="#D9D9D9"/>
        <circle cx="6.34375" cy="2.01953" r="1.17188" fill="#D9D9D9"/>
        <circle cx="6.34375" cy="7.96484" r="1.17188" fill="#D9D9D9"/>
        <circle cx="6.34375" cy="13.9102" r="1.17188" fill="#D9D9D9"/>
        </svg>
    `,
      }}
    />
  );
};
